const doc = [[3, 2, 1, 0, -1, -2, -3]];
module.exports = doc.length <= 1 ? doc[0] : doc;